import React, { useState, useEffect } from "react";
import { Box, Container, Typography, Grid, Paper, Divider, Button, Chip } from "@mui/material";
import { CalendarToday, PersonOutline, ArrowForward, AccessTime } from "@mui/icons-material";
import Homenavbar from "./Homenavbar";
import Homefooter from "./Homefooter";
import DemoRequestDialog from "./Components/DemoRequestDialog";
import { useNavigate } from "react-router-dom";
import { blogPosts } from "./blogData";

const Blog = () => {
    const [demoDialogOpen, setDemoDialogOpen] = useState(false);
    const [activeLink, setActiveLink] = useState('Blog');
    const navigate = useNavigate();

    useEffect(() => {
        window.scrollTo(0, 0);

        // Update Meta Tags
        document.title = "Blog | US IT Staffing & Bench Sales Insights | JobsnProfiles";
        const metaDescription = document.querySelector('meta[name="description"]');
        if (metaDescription) {
            metaDescription.setAttribute("content", "Explore the latest insights, strategies, and news for the US IT Staffing and Bench Sales community on the JobsnProfiles blog.");
        }
    }, []);

    const handleDemoOpen = () => setDemoDialogOpen(true);
    const handleDemoClose = () => setDemoDialogOpen(false);

    return (
        <Box sx={{ backgroundColor: "#F8FAFC", minHeight: "100vh" }}>
            <Homenavbar
                onRequestDemo={handleDemoOpen}
                activeLink={activeLink}
                setActiveLink={setActiveLink}
            />

            {/* Hero Section */}
            <Box
                sx={{
                    background: "linear-gradient(135deg, #1d3577 0%, #8f8854 100%)",
                    color: "white",
                    py: { xs: 12, md: 15 },
                    pb: { xs: 18, md: 22 },
                    textAlign: "center",
                    position: "relative",
                    overflow: "hidden"
                }}
            >
                <Container maxWidth="md">
                    <Typography
                        variant="h2"
                        sx={{
                            fontWeight: 800,
                            mb: 3,
                            letterSpacing: "-0.02em",
                            fontSize: { xs: "2.5rem", md: "3.5rem" },
                            fontFamily: "'Poppins', sans-serif"
                        }}
                    >
                        Our <Box component="span" sx={{ color: "#FF6B00" }}>Blog</Box>
                    </Typography>
                    <Typography
                        variant="h5"
                        sx={{
                            color: "rgba(255,255,255,0.8)",
                            lineHeight: 1.6,
                            fontWeight: 400,
                            maxWidth: "800px",
                            mx: "auto",
                            fontFamily: "'Poppins', sans-serif"
                        }}
                    >
                        The dedicated portal for insights, strategies, and news designed to revolutionize the U.S. IT staffing ecosystem.
                    </Typography>
                </Container>

                {/* Decorative Elements */}
                <Box sx={{
                    position: "absolute",
                    top: -100,
                    right: -100,
                    width: 300,
                    height: 300,
                    borderRadius: "50%",
                    background: "radial-gradient(circle, rgba(255,107,0,0.1) 0%, transparent 70%)"
                }} />
            </Box>

            <Container maxWidth="lg" sx={{ mt: -10, pb: 10, position: "relative", zIndex: 2 }}>
                <Paper
                    elevation={0}
                    sx={{
                        p: { xs: 4, md: 8 },
                        borderRadius: "24px",
                        boxShadow: "0 20px 40px rgba(0,0,0,0.05)",
                        backgroundColor: "#FFFFFF"
                    }}
                >
                    <Grid container spacing={6}>
                        <Grid item xs={12}>


                            <Paper
                                elevation={0}
                                sx={{
                                    borderRadius: "20px",
                                    overflow: "hidden",
                                    border: "1px solid #E2E8F0",
                                    transition: "all 0.3s ease",
                                    "&:hover": { borderColor: "#FF6B00", boxShadow: "0 10px 30px rgba(255,107,0,0.05)" }
                                }}
                            >
                                <Grid container>
                                    <Grid item xs={12} md={7}>
                                        <Box sx={{
                                            backgroundImage: blogPosts[0].image,
                                            backgroundSize: "cover",
                                            backgroundPosition: "center",
                                            backgroundRepeat: "no-repeat",
                                            minHeight: { xs: "300px", md: "450px" },
                                            height: "100%",
                                            position: "relative"
                                        }}>
                                            <Box sx={{
                                                position: "absolute",
                                                top: 20,
                                                left: 20,
                                                zIndex: 2
                                            }}>
                                                <Chip
                                                    label="MUST READ"
                                                    sx={{ bgcolor: "#FF6B00", color: "white", fontWeight: 700, borderRadius: "8px" }}
                                                />
                                            </Box>
                                        </Box>
                                    </Grid>
                                    <Grid item xs={12} md={5}>
                                        <Box sx={{ p: { xs: 4, md: 6 }, display: "flex", flexDirection: "column", height: "100%" }}>
                                            <Box sx={{ mb: 2 }}>
                                                <Chip
                                                    label={blogPosts[0].category}
                                                    sx={{ bgcolor: "rgba(255,107,0,0.1)", color: "#FF6B00", fontWeight: 600 }}
                                                />
                                            </Box>
                                            <Typography variant="h3" sx={{ fontWeight: 800, mb: 3, color: "#0F172A", fontSize: { xs: "1.5rem", md: "2rem" }, lineHeight: 1.3, fontFamily: "'Poppins', sans-serif" }}>
                                                {blogPosts[0].title}
                                            </Typography>
                                            <Typography sx={{ color: "#64748B", mb: 4, fontSize: "1.1rem", lineHeight: 1.8 }}>
                                                {blogPosts[0].excerpt}
                                            </Typography>

                                            <Box sx={{ mt: "auto", pt: 4, borderTop: "1px solid #F1F5F9", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                                <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                                                    <CalendarToday sx={{ color: "#94A3B8", fontSize: 20 }} />
                                                    <Box>
                                                        <Typography variant="caption" sx={{ color: "#94A3B8", fontWeight: 600 }}>{blogPosts[0].date}</Typography>
                                                    </Box>
                                                </Box>
                                                <Button
                                                    endIcon={<ArrowForward />}
                                                    variant="contained"
                                                    sx={{
                                                        backgroundColor: "#FF6B00",
                                                        color: "white",
                                                        borderRadius: "12px",
                                                        textTransform: "none",
                                                        px: 3,
                                                        py: 1.2,
                                                        fontWeight: 600,
                                                        "&:hover": { backgroundColor: "#E65100", transform: "translateX(4px)" },
                                                        transition: "all 0.3s ease"
                                                    }}
                                                    onClick={() => navigate(`/blog/${blogPosts[0].id}`)}
                                                >
                                                    Read More
                                                </Button>
                                            </Box>
                                        </Box>
                                    </Grid>
                                </Grid>
                            </Paper>
                        </Grid>
                    </Grid>
                </Paper>
            </Container>

            <Homefooter onRequestDemo={handleDemoOpen} />
            <DemoRequestDialog open={demoDialogOpen} onClose={handleDemoClose} />
        </Box>
    );
};

export default Blog;
